import app from './firebase'
import {getAnalytics} from 'firebase/analytics'

const analytics=getAnalytics(app)
export default analytics